/*
 * ============================================================
 * GLOGLOBITOS - SCRIPTS DE LA TIENDA
 * ------------------------------------------------------------
 * 1. Carro lateral: agrega productos sin recargar la página
 * 2. Selector de cantidad en tarjetas de producto
 * 3. Botón "volver arriba"
 * 4. Menú de escritorio que se abre al pasar el mouse
 * ============================================================
 */
(function () {
  'use strict';

  if (window.GLOGLOBITOS_READY) return;
  window.GLOGLOBITOS_READY = true;

  /* ============================================================
   * 1. CARRO LATERAL
   * ============================================================ */

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
  }

  function replaceFromSection(html, selector) {
    if (!html) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector(selector);
    const current = document.querySelector(selector);
    if (fresh && current) current.replaceWith(fresh);
  }

  function renderDrawer(data) {
    const drawer = getDrawer();
    if (!drawer) return;

    if (typeof drawer.renderContents === 'function') {
      drawer.renderContents(data);
      return;
    }

    const html = data.sections && data.sections['cart-drawer'];
    if (!html) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const freshInner = parsed.querySelector('cart-drawer .drawer__inner');
    const currentInner = drawer.querySelector('.drawer__inner');

    if (freshInner && currentInner) currentInner.innerHTML = freshInner.innerHTML;
    drawer.classList.remove('is-empty');
    openDrawer();
  }

  async function addToCart(form) {
    const idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) {
      throw new Error('No se encontró la variante del producto.');
    }

    const params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (typeof value === 'string') params.append(key, value);
    });
    params.set('sections', 'cart-drawer,cart-icon-bubble');
    params.set('sections_url', window.location.pathname);

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: params.toString(),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.description || data.message || 'No se pudo agregar el producto.');
    }
    return data;
  }

  // Se escucha en fase de captura para adelantarse al envío normal del tema.
  document.addEventListener(
    'submit',
    async function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.closest('product-form') || form.closest('cart-drawer')) return;
      if (!getDrawer()) return; // Sin carro lateral se usa el comportamiento normal.

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (form.dataset.ggBusy === 'true') return;
      form.dataset.ggBusy = 'true';

      const button = form.querySelector('[name="add"]') || form.querySelector('[type="submit"]');
      const label = button ? button.innerHTML : '';
      if (button) {
        button.disabled = true;
        button.innerHTML = '<span>AGREGANDO...</span>';
      }

      try {
        const data = await addToCart(form);
        if (data.sections) replaceFromSection(data.sections['cart-icon-bubble'], '#cart-icon-bubble');
        renderDrawer(data);

        setTimeout(function () {
          const drawer = getDrawer();
          if (drawer && !drawer.classList.contains('active')) openDrawer();
        }, 50);
      } catch (error) {
        alert(error.message || 'No se pudo agregar el producto.');
      } finally {
        if (button) {
          button.disabled = false;
          button.innerHTML = label;
        }
        delete form.dataset.ggBusy;
      }
    },
    true
  );

  /* ============================================================
   * 2. SELECTOR DE CANTIDAD EN TARJETAS
   * ------------------------------------------------------------
   * El stock llega desde Liquid en data-stock, sin consultas
   * extra al servidor por cada tarjeta.
   * ============================================================ */

  function setupQuickAdd(scope) {
    (scope || document).querySelectorAll('.quick-add-product-form').forEach(function (productForm) {
      if (productForm.dataset.quantityReady === 'true') return;

      const trigger = productForm.querySelector('.quantity-trigger');
      const box = productForm.querySelector('.quick-add-quantity');
      const input = productForm.querySelector('.quick-add-quantity__input');
      const minus = productForm.querySelector('.quantity-minus');
      const plus = productForm.querySelector('.quantity-plus');
      if (!trigger || !box || !input) return;

      productForm.dataset.quantityReady = 'true';

      const stock = parseInt(input.dataset.stock, 10);
      const maxQty = isNaN(stock) ? Infinity : Math.max(stock, 1);

      function clamp(value) {
        const qty = parseInt(value, 10) || 1;
        return Math.min(Math.max(qty, 1), maxQty);
      }

      function refresh() {
        const qty = clamp(input.value);
        input.value = qty;
        if (minus) minus.disabled = qty <= 1;
        if (plus) plus.disabled = qty >= maxQty;
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        trigger.hidden = true;
        box.hidden = false;
        input.value = 1;
        refresh();
      });

      if (minus) {
        minus.addEventListener('click', function (event) {
          event.preventDefault();
          input.value = clamp(input.value) - 1;
          refresh();
        });
      }

      if (plus) {
        plus.addEventListener('click', function (event) {
          event.preventDefault();
          input.value = clamp(input.value) + 1;
          refresh();
        });
      }

      input.addEventListener('change', refresh);
      box.hidden = true;
      refresh();
    });
  }

  /* ============================================================
   * 3. BOTÓN VOLVER ARRIBA
   * ============================================================ */

  function setupBackToTop() {
    const button = document.getElementById('gg-back-to-top');
    if (!button) return;

    let ticking = false;
    function update() {
      button.classList.toggle('is-visible', window.scrollY > 500);
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    update();
  }

  /* ============================================================
   * 4. MENÚ DE ESCRITORIO AL PASAR EL MOUSE
   * ============================================================ */

  function setupHoverMenu() {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;

    document.querySelectorAll('.header__inline-menu details').forEach(function (details) {
      let closeTimer;

      details.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (other) {
          if (other !== details) other.removeAttribute('open');
        });
        details.setAttribute('open', '');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 180);
      });
    });
  }

  /* ============================================================
   * 5. CAMPAÑAS CON FECHA (Cyber Monday)
   * ------------------------------------------------------------
   * Los elementos con data-gg-cyber se muestran solo en los
   * estados indicados en data-show ("upcoming", "live"), según
   * data-start y data-end. Se revisa en el navegador para que
   * el cambio de estado sea exacto aunque la página esté en caché.
   * ============================================================ */

  function cyberState(el, now) {
    const start = Date.parse(el.dataset.start);
    const end = Date.parse(el.dataset.end);
    if (isNaN(start) || isNaN(end)) return 'ended';
    if (now < start) return 'upcoming';
    if (now <= end) return 'live';
    return 'ended';
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function refreshCyber() {
    const now = Date.now();
    document.querySelectorAll('[data-gg-cyber]').forEach(function (el) {
      const state = cyberState(el, now);
      const allowed = (el.dataset.show || 'live').split(' ');
      el.hidden = allowed.indexOf(state) === -1;
      el.dataset.state = state;

      const count = el.querySelector('[data-gg-cyber-count]');
      if (!count || el.hidden) return;

      const target = Date.parse(state === 'upcoming' ? el.dataset.start : el.dataset.end);
      const left = Math.max(0, target - now);
      const units = {
        d: Math.floor(left / 864e5),
        h: pad(Math.floor((left % 864e5) / 36e5)),
        m: pad(Math.floor((left % 36e5) / 6e4)),
        s: pad(Math.floor((left % 6e4) / 1e3)),
      };
      count.querySelectorAll('[data-u]').forEach(function (unit) {
        unit.textContent = units[unit.dataset.u];
      });
    });
  }

  function setupCyber() {
    if (!document.querySelector('[data-gg-cyber]')) return;
    refreshCyber();
    setInterval(refreshCyber, 1000);
  }

  /* ============================================================
   * INICIO
   * ============================================================ */

  function init() {
    setupQuickAdd();
    setupBackToTop();
    setupHoverMenu();
    setupCyber();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupQuickAdd(event.target);
  });

  // Las tarjetas que se cargan después (filtros, paginación) también reciben el selector.
  let quickAddScheduled = false;
  new MutationObserver(function () {
    if (quickAddScheduled) return;
    quickAddScheduled = true;
    requestAnimationFrame(function () {
      quickAddScheduled = false;
      setupQuickAdd();
    });
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();
